<button
    *ngIf="buttonText || buttonIcon"
    type="button"
    [icon]="this.buttonIcon"
    [label]="this.buttonText"
    pButton
    (click)="openModal()"
    style="margin-right: 10px;"
></button>

<p-dialog
    *ngIf="!displayAsTableOnly"
    [header]="this.modalText"
    [(visible)]="displayTable"
    [style]="{width: '80%', align: 'center' }"
    appendTo="body"
    [resizable]="true"
    [maximizable]="true"
    [closeOnEscape]="true"
>
    <div class="ui-g">
        <div class="p-g-12">
            <tree-table class="tree-table-custom-align"
                *ngIf="!error"
                [inputTreeNodes]="accountsForTable"
                [treeColumns]="tableColumns"
                [loadingTreeNodes]="loading"
                [selectionMode]="this.selectionMode"
                [(selected)]="this.selected"
            ></tree-table>
            <p *ngIf="error">{{error}}</p>
        </div>
    </div>
</p-dialog>

<div *ngIf="displayAsTableOnly">
    <tree-table class="tree-table-custom-align"
    *ngIf="!error"
    [inputTreeNodes]="accountsForTable"
    [treeColumns]="tableColumns"
    [loadingTreeNodes]="loading"
    [selectionMode]="this.selectionMode"
    [(selected)]="this.selected"
    ></tree-table>
    <p *ngIf="error">{{error}}</p>
</div>